import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithIam from '../../app/baseQueryWithIam'
import { ListResponse, ManagerState, PaginationState } from '../types'

interface QueryParams extends PaginationState {
    roles: Array<string>
}

export const managerApi = createApi({
    reducerPath: 'managerApi',
    baseQuery: baseQueryWithIam,
    tagTypes: ['Manager'],
    endpoints: (build) => ({
        fetchAllManagers: build.query<ListResponse<ManagerState>, QueryParams>({
            query: (params) => ({
                url: `managers`,
                method: 'GET',
                params,
            }),
            providesTags: (result) =>
                result
                    ? [
                          ...result.data.map(({ id }) => ({
                              type: 'Manager' as const,
                              id,
                          })),
                          { type: 'Manager', id: 'LIST' },
                      ]
                    : [{ type: 'Manager', id: 'LIST' }],
            transformResponse: (response: {
                data: ListResponse<ManagerState>
            }) => ({
                data: response.data.data,
                pageNumber: response.data.pageNumber,
                totalCount: response.data.totalCount,
                totalPages: response.data.totalPages,
            }),
        }),

        createManager: build.mutation<void, ManagerState>({
            query: (manager) => ({
                url: 'managers',
                method: 'POST',
                body: manager,
            }),
            invalidatesTags: [{ type: 'Manager', id: 'LIST' }],
        }),

        updateManager: build.mutation<void, ManagerState>({
            query: (manager) => ({
                url: `managers/${manager.id}`,
                method: 'PUT',
                body: manager,
            }),
            invalidatesTags: [{ type: 'Manager', id: 'LIST' }],
        }),

        deleteManager: build.mutation<void, number>({
            query: (id) => ({
                url: `managers/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [{ type: 'Manager', id }],
        }),
    }),
})
